import React from "react";

import {cn} from "../../../../lib/utils";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faBan} from "@fortawesome/pro-solid-svg-icons";

const EKey = ({methods, isOpen: {EKey}}) => {
    const KEYS = ["none", "Integra", "Wallmount", "Keypad"];
    const {register} = methods;
    return (
        <div
            className={cn(
                "section grid grid-cols-4 overflow-hidden transition-all h-0 opacity-0",
                {
                    ["h-full opacity-100"]: EKey.isOpen,
                }
            )}
        >
            {KEYS.map((name) => (
                <div key={name} className="group">
                    <div
                        key={name}
                        className="relative flex flex-col items-center justify-center gap-2 group-has-[:checked]:bg-[#555454] p-3"
                    >
                        {name === 'none' ? (
                            <div className='h-20 w-full flex items-center justify-center'>
                                <FontAwesomeIcon className='w-full h-12 text-gray-600 group-has-[:checked]:text-white'
                                                 icon={faBan}/>
                            </div>
                        ): <div className='flex h-20 items-center justify-center'>
                            <img
                                className="size-14"
                                src={`/assets/e_key/${name}.jpg`}
                                alt={name}
                            />
                        </div>
                        }
                        <p className="text-gray-600 text-xs group-has-[:checked]:text-white capitalize">
                            {name.replace("_", " ")}
                        </p>
                        <input
                            className="absolute inset-0 h-full w-full opacity-0 z-20 cursor-pointer "
                            type="radio"
                            id="type"
                            value={name}
                            {...register("e_key_entry")}
                        />
                    </div>
                </div>
            ))}
        </div>
    );
};

export default EKey;

